import general from './general.json';
import * as education from './education';
import skills from './skills.json';
import * as experience from './experience';
import * as gallery from './gallery';
import * as projects from './projects';
import * as certifications from './certifications';


const index = {
	general,
	education,
	skills,
	experience,
	gallery,
	projects,
	certifications,
};

export { general, education, skills, experience, gallery, projects, certifications };

export default index;
